import Header from '../components/Header/Header';
import Credentiallayoutbox from '../components/Credentiallayoutbox/Credentiallayoutbox';
import Profilemenubox from '../components/Profilemenubox/Profilemenubox';
import Skillsearchbar from '../components/Skillsearchbar/Skillsearchbar';
import Footer from '../components/Footer/Footer';
import Skillslidebox from '../components/Skillslidebox/Skillslidebox';
import Profilebannerbox from '../components/Profilebannerbox/Profilebannerbox';
import Copilot from '../Copilot/Copilot';
import Addskillbtn from '../components/Addskillbtn/Addskillbtn';
import React from 'react';
import { transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".billing-option").click(function(){$(".billing-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".bl-p-section").removeClass("active"),$(".bl-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".usage-option").click(function(){$(".usage-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".u-p-section").removeClass("active"),$(".u-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".cpc-tr").click(function(){$(".cpc").show().delay(1e3).fadeOut()}),$(".user-dots").on("click",function(){$(this).toggleClass("active")}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-skills-v7.webflow.io");$(this).attr("href",e)}),$(".submit-prompt").click(function(){$(".human-text").removeClass("hide"),setTimeout(function(){$(".s1")[0].style.display="flex"},1e3),setTimeout(function(){$(".s2")[0].style.display="flex"},2e3)}),$(".skills-option").click(function(){var e=$(this).attr("data-name");$(".skills-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$("html, body").animate({scrollTop:$(".scroll-div[data-name="+e+"]").offset().top-79},1e3)}),$(".item_options").each(function(){$(this).mouseover(function(){var e=$(this).closest("a").attr("href");$(this).closest("a").removeAttr("href"),$(this).closest("a").data("default_url",e)}),$(this).mouseout(function(){$(this).closest("a").data("default_url")&&$(this).closest("a").attr("href",$(this).closest("a").data("default_url"))}),$(this).click(function(){0<$(this).closest(".w-slider-mask").length&&($(this).closest(".w-slider-mask")[0].style.overflow="visible",$(".sl_c").css("z-index","auto"),$(this).closest(".sl_c")[0].style.zIndex="5",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="hidden"}),$(this).closest(".w-slide")[0].style.visibility="visible"),$(".options_div").each(function(e){$(this)[0].style.display="none"}),$(this).find(".options_div").toggle()})}),$(".item_options").click(function(e){e.stopPropagation()}),$(window).click(function(){$(".options_div").each(function(e){$(this)[0].style.display="none",0<$(this).closest(".w-slider-mask").length&&($(this).closest(".sl_c")[0].style.zIndex="auto",$(this).closest(".w-slider-mask")[0].style.overflow="hidden",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="visible"}))})}),$(".mobile_nav_trigger").click(function(){"block"!=$(".mobile_nav")[0].style.display?$(".mobile_nav")[0].style.display="block":$(".mobile_nav")[0].style.display="none"}),$(window).click(function(){$(".mobile_nav")[0].style.display="none"}),$(".mobile_nav").click(function(e){e.stopPropagation()}),$(".mobile_nav_trigger").click(function(e){e.stopPropagation()}),$(".link-options-2").click(function(){var e=$(this).attr("data-name");$(".link-options-2").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(e){$(this).removeClass("active")}),$(".panel[data-name="+e+"]").addClass("active")}),$(".open-chat").click(function(){$(".chatbox").addClass("open"),$(".ch_c").removeClass("hidden")}),$(".minimize").click(function(){$(".chatbox").removeClass("open"),$(".ch_c").addClass("hidden")}),$(".div-block-163").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(".div-block-167").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(window).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"})}),$(".div-block-163").click(function(e){e.stopPropagation()}),$(".div-block-167").click(function(e){e.stopPropagation()}),$(".br_menu").click(function(){$(".br_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".browse_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.browse_panel[data-name="\'+e+\'"]\')[0].style.display="flex"}),$(".f_row").each(function(){$(this).click(function(){$(this).find(".img_v").toggle(),$(this).find(".img_h").toggle(),$(this).next().toggle()})}),$(".f_box .text-field.w-input").each(function(){$(this).keyup(function(){let i=$(this).val();var e=$(this).parent().parent().find(".checkbox-field");$(e).each(function(e){0<=$(this).find(".checkbox-label")[0].innerHTML.toLowerCase().indexOf(i.toLowerCase())?$(this)[0].style.display="block":$(this)[0].style.display="none"})})}),$(".feed-option").click(function(){$(".feed-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".feed_cont").each(function(e){$(this).removeClass("active")}),$(\'.feed_cont[data-name="\'+e+\'"]\').addClass("active"),"messages"==e||"following"==e||"followers"==e?$("body").addClass("messages_active"):$("body").removeClass("messages_active")});var e=window.location.href,e=(console.log(e),e.split("#")[1]);function i(){$(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"),$(".tw_r.new_m_user").each(function(e){$(this).removeClass("active")})}e&&(e=document.querySelector(\'.prof_menu[data-name="\'+e+\'"]\'))&&e.click(),document.getElementById("pink0").oninput=function(){var e=(this.value-this.min)/(this.max-this.min)*100;this.style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+e+"%, #fff "+e+"%, white 100%)"},$("input[type=range]").on("input",function(){var t=$(this).attr("data-index"),l=$(this).val();$("#i"+t).html(l);{let i=0;$(".is-pink0").each(function(e){0<$(this).val()&&(i+=1)}),console.log(i),$("#rs").html(i),3==i?($(".skills_allow")[0].style.display="flex",$(".skills_next0").hide()):($(".skills_allow").hide(),$(".skills_next0").show())}{let e="",i="";0==l?(e="NOT RATED",i="0"):1==l?(e="BEGINNER",i="10px"):2==l?(e="NOVICE",i="60px"):3==l?(e="INTERMEDIATE",i="80px"):4==l?(e="ADVANCED",i="130px"):5==l&&(e="EXPERT",i="160px"),$(".level-text")[t].style.marginLeft=i,$(".level-text")[t].innerHTML=e}l=$(this)[0],t=(l.value-l.min)/(l.max-l.min)*100;$(this)[0].style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+t+"%, #e9eaeb "+t+"%, #e9eaeb 100%)"}),$(".is-pink0").on("touchstart",function(e){}),$(".is-pink0").on("touchend",function(){}),$(".more").click(function(){$(this).hide(),$(".link-block-7").each(function(e){$(this).removeClass("hide")})}),$(".down_arr").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$(".skills_next0.disabled").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills-v2.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$(".c-block").click(function(){$(".cm_popup_div")[0].style.display="flex"}),$(".comment-c").click(function(){$(".cm_popup_div")[0].style.display="none"}),$(".tw-img-trigger").click(function(){$("#tw-img-uploader").trigger("click")}),$(".likes_tab").click(function(){$(".likes_tab").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".profile_text").each(function(e){$(this).removeClass("active")}),$(\'.profile_text[data-name="\'+e+\'"]\').addClass("active"),$(".profile_list").each(function(e){$(this).removeClass("active")}),$(\'.profile_list[data-name="\'+e+\'"]\').addClass("active")}),$(".message_div .tw_r").click(function(){$(".message_div").addClass("mobile_hidden"),$(".chat_div").removeClass("mobile_hidden")}),$(".show_msg_div").click(function(){$(".message_div").removeClass("mobile_hidden"),$(".chat_div").addClass("mobile_hidden")}),$(".follow_tab").click(function(){var e=$(this).attr("data-name");e&&$(\'.feed-option[data-name="\'+e+\'"]\').click()}),$(".follow_tabs_back").click(function(){$(\'.feed-option[data-name="home"]\').click()}),$(".create-group").click(function(){$(".create_group_popup").removeClass("hidden"),$(".new_message_popup").addClass("hidden")}),$(".back_dc").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden")}),$(".cancel_user.c_i").click(function(){i()}),$(".next_form.n_m.next").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden"),$(this).hasClass("disabled")||($(".nm_popup")[0].style.display="none",i())}),$(".new_message").click(function(){$(".nm_popup")[0].style.display="flex"}),$(".tw_r.new_m_user").each(function(e){$(this).click(function(){$(this).toggleClass("active");let i=!1;$(".tw_r.new_m_user").each(function(e){$(this).hasClass("active")&&(i=!0)}),i?($(".n_m.next").removeClass("disabled"),$(".create-group").addClass("hide"),$(".group-users").addClass("show")):($(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"))})}),$(".div-block-181").each(function(e){$(this).click(function(){$(this).find(".div-block-193").toggle()})}),$(".cancel_type_popup").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".cancel_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".add_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".div-block-176").each(function(e){$(this).click(function(){$(".add_content_popup")[0].style.display="none",$(".type_content_popup")[0].style.display="block"})}),$(".content_menu").click(function(){$(".content_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".conent_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.conent_panel[data-name="\'+e+\'"]\')[0].style.display="block","type"==e?$(".add_content_btn").addClass("disabled"):$(".add_content_btn").removeClass("disabled")}),$(".add_content_div").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_content_popup")[0].style.display="block"})}),$(".add_content_btn").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_content").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_popup").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".dc").click(function(){$(".popup_div")[0].style.display="flex",$(".body")[0].style.overflow="hidden",$(".dc_popup")[0].style.display="block"}),$(".cancel_dc").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_dc_div").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_profile_trigger").click(function(){$(".popup_div")[0].style.display="flex",$(".edit_profile_pop")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".cancel_edit_profile").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_edit_prof").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".save_profile_info").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_rating").click(function(){$(".skill_report_popup")[0].style.display="none",$(".rate_skill_popup")[0].style.display="block"}),$(".rate_skill_close").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".cancel_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".confirm_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".skill_box").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".skill_report_popup").toggle()})}),$(".cancel_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".confirm_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".add_skill").click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_skill_popup").toggle()}),$(".confirm_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".cancel_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".dash_nav_item").click(function(){$(".dash_nav_item").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this)[0].innerHTML;$(".panel").each(function(e){$(this)[0].style.display="none"}),$(".panel-"+e.toLowerCase())[0].style.display="flex"}),window.location.hash.substr(1)&&(console.log("fires"),e=window.location.hash.substr(1),$(\'.prof_menu[data-name="\'+e+\'"]\').click());e=new URL(window.location.href).searchParams.get("s");console.log(e),e&&$(\'.prof_menu[data-name="\'+e+\'"]\').trigger("click")}),jQuery.fn.onPositionChanged=function(t,e){null==e&&(e=100);var l,o,s=$(this[0]);return s.length<1||(o=l=null,setInterval(function(){if(null==s||s.length<1)return s;null==l&&(l=s.position()),null==o&&(o=s.offset());var e=s.position(),i=s.offset();l.top==e.top&&l.left==e.left||($(this).trigger("onPositionChanged",{lastPos:l,newPos:e}),"function"==typeof t&&t(l,e),l=s.position()),o.top==i.top&&o.left==i.left||($(this).trigger("onOffsetChanged",{lastOff:o,newOff:i}),"function"==typeof t&&t(o,i),o=s.offset())},e)),s},$(window).on("scroll",function(){$(window).scrollTop()+$(window).height()==$(document).height()?$(".down_arr").hide():$(".down_arr").show()});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '$(document).ready(function(){$(".discover-credentials").click(function(){$(".popup_div").addClass("active"),$(".dc_popup").addClass("active"),$(".credentials-popup").addClass("active")}),$(".cancel_dc_div, .cancel_dc").click(function(){$(".popup_div").removeClass("active"),$(".dc_popup").removeClass("active"),$(".credentials-popup").removeClass("active")}),$(".skill-link").click(function(){$(".popup_div").addClass("active"),$(".rate_skill_popup").addClass("active")}),$(".rate_skill_close, .cancel_skill_rate").click(function(){$(".popup_div").removeClass("active"),$(".rate_skill_popup").removeClass("active")}),$(".add_skill").click(function(){$(".popup_div").addClass("active"),$(".add_skill_popup").addClass("active")}),$(".cancel_add_skill").click(function(){$(".popup_div").removeClass("active"),$(".add_skill_popup").removeClass("active")}),$(".confirm_add_skill").click(function(){$(".popup_div").removeClass("active"),$(".add_skill_popup").removeClass("active")}),$(".edit_profile_trigger").click(function(){$(".popup_div").addClass("active"),$(".edit_profile_pop").addClass("active")}),$(".cancel_edit_profile").click(function(){$(".popup_div").removeClass("active"),$(".edit_profile_pop").removeClass("active")}),$(".cancel_edit_prof").click(function(){$(".popup_div").removeClass("active"),$(".edit_profile_pop").removeClass("active")}),$(".save_profile_info").click(function(){$(".popup_div").removeClass("active"),$(".edit_profile_pop").removeClass("active")}),$(".dc").click(function(){$(".popup_div").addClass("active"),$(".dc_popup").addClass("active")}),$(".cancel_dc").click(function(){$(".popup_div").removeClass("active"),$(".dc_popup").removeClass("active")}),$(".cancel_dc_div").click(function(){$(".popup_div").removeClass("active"),$(".dc_popup").removeClass("active")});var e=$("#email-form-4"),i=$("<div>").append(e.contents()),e=(e.replaceWith(i),$(".div-block-276.second .form-2")),i=$(\'<div class="second-input">\').append(e.contents());e.replaceWith(i)}),$(".ask-input").keydown(function(e){13==e.which&&""!=$(".ask-input").val()&&$(".div-block-305.fire-f").trigger("click")}),$(".form-block-8").removeClass("w-form"),$(".close-box").click(function(){$(".body").removeClass("chat-active")}),$(".div-block-305.fire-f").click(function(e){var i,t,o;""!=$(".ask-input").val()&&($(".div-block-276.first")[0].style.display="none",$(".div-block-276.second")[0].style.display="flex",i=0,t="Quantum computing is a field that aims to develop computers that use the principles of quantum physics to perform computations.",o=20,setTimeout(function e(){var c,a;$(".history").removeClass("hidden"),i<t.length?($(".text-block-187")[0].innerHTML+=t.charAt(i),i++,o=Math.floor(15*Math.random())+1,setTimeout(e,o)):($(".text-block-187")[0].classList.add("no-after"),c=0,a="One of the most important concepts in quantum computing is superposition, which allows qubits to be in multiple states simultaneously.",setTimeout(function(){$(".text-block-187")[1].style.display="block",function e(){var i,t;c<a.length?($(".text-block-187")[1].innerHTML+=a.charAt(c),c++,o=Math.floor(10*Math.random())+1,setTimeout(e,o)):($(".text-block-187")[1].classList.add("no-after"),$(".reg-btn").removeClass("hidden"),$(".sources").removeClass("hidden"),$(".related").removeClass("hidden"),$(".reg").addClass("reg-show"),$(".new-chat-text").html(""),$(".new-chat-text").addClass("with_blink"),i=0,t="Quantum computing",setTimeout(function(){$(".text-block-169")[1].style.display="block",function e(){$(".div-block-325").addClass("rel"),i<t.length?($(".new-chat-text")[0].innerHTML+=t.charAt(i),i++,o=Math.floor(100*Math.random())+4,setTimeout(e,o)):$(".new-chat-text").removeClass("with_blink")}()},1e3))}()},10))},2e3))});'
    ),
    isAsync: false,
  },
];

let Controller;

class PublicProfileNewView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/PublicProfileNewController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = PublicProfileNewView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '6596f9cde7a06c303cf07fbf';
    htmlEl.dataset['wfSite'] = '6596e21ac435cac3c66baad8';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      PublicProfileNewView.Controller !== PublicProfileNewView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-skillspro-v3.webflow.css);


            .full.w-bar .right-content {
              display: flex !important;
              flex-direction: column !important;
          }
            @media screen and (min-width: 768px)  and  (max-width: 1090px){
              .div-block-19.cert-grid{
                  grid-template-columns: 1fr;
              }
          }
            .pr-text:after, .pr-text-2:after, .pr-text-3:after, .pr-text-4:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .div-block-346{
            	border-radius:2px;
            }
            .up{
            	white-space: nowrap;
            }
            .text-block-189{
            	margin-bottom:15px;
            }
            .div-block-345.u-p-section, .div-block-345.bl-p-section{
            	padding-top:15px !important;
            }
            .div-block-352.three-dots-menu{
            	height:132px !important;
            }
            .text-block-203{
            	margin-bottom:15px;
            }
            .div-block-357{
            	padding-bottom:12px;
            }
            .form-block.s_skill.r-search.s-r.search-admin{
            	margin-bottom:15px;  
            }
            .div-block-345.bl-p-section{
              	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .div-block-345.d-p-section{
            	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .cpc{
             margin-top:4px !important;
            }
            .user-dots.active{
              background-color: #f7f9fd;
          }
            .d-admin-m{
              height: 36px !important;
              width:152px !important;
          }
            .user-dots.active .d-admin-m{
              display:block; 
          }
            .pm-33{
            	height: 100%;
              display: flex;
              flex-direction: column;
            }
            .pm-272{
            	display: flex;
              flex-direction: column;
              flex-grow: 1;
            }
            .div-block-358{
            	    flex-grow: 1;
                  align-items: start;
            }
            .chat-box.logged-in.jc-start{
            	justify-content:start !important;
            }
          @media only screen and (max-width: 767px) {
              .text-block-167.new-chat-text, .text-block-186,  .text-block-184, .text-block-169 , .text-field-11.ask-input, .all,
              .text-block-192, .rel-answer.open .answer-text, .text-block-189, .textarea-2, .w_i, .create-text, .add-text,
              .rec-h, .text-field.n_text.s-f, .text-block-167.add-resource, .text-block-199, .text-field-12, .text-block-159-train, .text-block-196,
              .text-block-198, .text-block-160, .div-block-340-train .link-options-train, .text-block-165-tr, .text1-tr, .paragraph-tr, .text-block-163-tr, .text-block-86-tr,
              .text-block-86-tr, .instructor-name-train, .instructor-subtitle-train, .instructor-school-train, .text-block-165-train, .text-block-26, 
              .text-block-197, .test-name-3, .text-block-86, .text-block-120, .text-block-86, .question-title-te
              {
                  font-size: 16px !important;
              }
                .instructor-img-train{
                  width: 70px !important;
                  height: 70px !important
              }
              .text-block-191, .text-block-190, .b-link{
                  font-size:14px;
              }
              .image-45{
                  height:18px;
              }
              .content-2.r-hide{
                  padding-bottom:14px !important
              }
              .text-block-16.p, .text-block-124{
                  font-size:13px;
              }
          }
            @media only screen and (max-width: 767px) {
              .sign-in-panel {
              	padding-top:49px;
              }
              .chat-box-sign-in.hidden.open{
              border:none !important;
                height: auto !important;
              }
            }
            .chat-box-sign-in.hidden.open{
            	height:auto;
              padding-bottom:12px;
          	    	    margin-right:0;
              height:100%;
            }
            .or-3-copy{
            	text-align:center;
            }
            .chat-box-sign-in.hidden{
            	    border: 1px solid #dde1e6 !important;
            }
            .chat-1 .content-2{
            	padding-bottom:0 !important;
            }
            .div-block-305:hover {
              background-color: #fff;
          }
            .related_f{
            	display:none;
            }
            .sources_f{
            	display:none;
            }
            .create-div .text-field{
            	width: 100%;
            }
            .add_content_popup .div-block-333{
            	flex: inherit !important;
            }
            .b-link:hover{
            	text-decoration: underline;
            }
            .div-block-347{
            	padding:10px;
              z-index: 2222;
            }
            .b-link{
            	margin-right:6px !important;
            }
            .div-block-262.last{
            	padding-bottom:3px;
            }
            .about_p_popup_resource .about-box-train .faq-question-wrap-2{
              margin-bottom:0;
            }
              .about_p_popup_resource .faq-question-bar-2{
              padding-bottom:0;
            }
            .link-options-train.link-options:hover{
            	border-bottom: 2px solid #6cafe1;
            }
            .about-box-train .text-block-120{
            	    color: #6cafe1;
            }
            .question-title-te, .test-name-3{
             color: #6cafe1;
            }
            .link-options-train{
            	padding-right:0 !important;
            }
            .div-block-340-train{
            	padding-bottom:5px;
            }
            .about-box-train .faq-question-wrap-2{
            	padding-bottom:0;
            }
            .about-vox-train .accordion__title__faq-2{
            	padding:10px !important;
            }
            .about-box-train .div-block-270{
             padding:10px;
            }
            .link-options-train{
            	font-size:14px !important;
            }
            .rec-h{
            	height:40px;
            }
            .outcome-train .image-118{
            	width:16px;
              height:16px;
            }
            .div-block-333{
            	overflow:hidden;
            }
            .outcome-train .skill-div-2{
            	margin-bottom:5px;
              float:left !important;
              clear:both;
            }
            .outcome-train{
            	overflow:hidden;
            }
            .textarea-2{
            	height:250px !important;
              border-radius: 6px;
            }
            .text-block-187-sum:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .chat-1.hidden{
            	display:none;
            }
            .div-block-272{
            	z-index: 222;
            }
            .div-block-329{
            	max-width:350px;
            }
            .chat-box.hidden{
            	flex-grow: 1;
            }
            .chat-box.hidden.h-auto{
            	height: auto !important;
            }
            .rel-answer.open .answer-text{
            	display:block;
            }
            .right-content {
            	    max-height: 100vh;
              overflow: auto;
            }
            .div-block-325.rel{
            	padding-top:14px;
            }
            .h-hide{
            	display:none !important;
            }
            .all .grow-flex{
            	    overflow: auto;
            }
            .rec-div:hover .div-block-332{
              display: block;
          }
            @media screen and (max-width: 767px) {
              .all .grow-flex{
                  max-height: 89vh;
              }
          }
          /* .all .div-block-325.rel{
              position:absolute !important;
          } */
                .div-block-294-open:hover > .hidden-img{
              display:none;
          }
          .div-block-294-open:hover > .hidden-img-rot{
              display:block;
          }
            .rel-answer.open .answer-text{
              height: auto;
              margin-bottom:10px;
          }
            .div-block-294:hover > .image-116{
              display:none;
          }
          .div-block-294:hover > .image-93-rot{
              display:inline-block;
          }
            .rel-row.open .div-block-294{
              display:none;
          }
          .rel-row.open .div-block-294-open{
              display:inline-block;
          }
            .chat-response .form-2{
            	height:40px;
            }
            .chat-box.hidden{
            	height:100% !important;
            }
            .graphs-row{
                	overflow: auto !important;
            }
            .second-input{
            	display:flex;
              align-items:center;
            }
            	@media screen and (max-width: 767px) {
                    .html-embed-2.skill-point.dblock.w-embed.w-script{
                  overflow: auto !important;
                min-width: 600px !important;
              }
                    .reg-show{
                  display: block;
              }
              .form-block-8{
                  padding-top: 0;
              }
                	    .div-block-280{
                  display: none;;
              }
                	    .div-block-272{
                  position: fixed;
                  top: 0;
                  width: 100%;
                  background: #fff;
              }
              .div-block-52{
                  padding-top: 59px;
              }
                	    .chat-2{
                  position: fixed;
                  bottom: 0;
                  width: 100%;
                  background: #fff;
                                margin-bottom: 0;
                  padding-bottom: 14px;
              }
                    .content-2{
                  padding-bottom:100px;
              }
                	    .full.w-bar .chat-box.hidden{
                  border-radius: 0;
                  border: none !important;
              }
                	    .body.chat-active{
                  overflow: hidden;
              }
             .full.w-bar .image-106.right{
                  padding-right:13px;
              } 
              .div-block-325{
                  position: fixed !important;
                  background: #fff;
                  padding-top:12px;
                        margin-left: 0;
                  margin-right: 0;
                        padding-left: 10px;
                  padding-right: 10px;
              }
              .grow-flex{
                  padding-bottom: 66px;
              }
              .full.w-bar .right-content{
                  width: 100% !important;
                        overflow: auto;
                        padding: 0;
              }
              .chat-box{
                  min-height: auto;
                  height:auto;
                  flex-grow: 1;
              }
              .mob-grid{
                  margin-left: auto;
                  margin-right: auto;
              }
              .resize-img{
                  display: none;;
              }
                    .div-block-326{
                  min-width: auto !important;
              }
            }
              @media screen and (max-width: 390px) {
              .div-block-275{
                  margin-right: 8px;
              }
          }
              .with_blink:after{
            	-webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
              color: #21232e;
            }
            	  .no-after:after{
            	content:\"\" !important;
            }
            @keyframes blink {
            0% {
              display: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          /* Apply the animation to an element */
          .blink {
            animation: blink 1s ease-in-out infinite;
          }
          .text-block-187:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .full.w-bar .p_menu {
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
              .chat-box.active.hidden{
            	border-radius: 4px;
            }
          .full.w-bar .right-content{
              display: flex !important;
              flex-direction: column !important;
          }
            .full.w-bar .image-116.right .sm{
              margin-left: auto;
          }
            .full.w-bar .chat-box.hidden{
              display: flex;
          }
            .full.w-bar .p_menu.w_bar{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            .full.w-bar .panels_cont{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            	.full.w-bar .main-content{
              padding-right:380px;
          }
            .full.w-bar .right-content{
              display: block;
          }
          .full.w-bar .right-content{
              width:380px;
          }
            .chat-box{
            	width:auto !important;
              border: 1px solid #dde1e6 !important;
            }
            .about-panels{
              min-height: calc(100vh - 79px - 59px);
          }
          @media screen and (max-width: 767px)  and (min-width: 480px){
            .chatbox.open .open-chat{
              display: none;
            }
            .ch_c{
              margin-bottom: 0;
            }
          }
            .chatbox {
            padding-bottom: env(safe-area-inset-bottom);
                padding-top: env(safe-area-inset-top);
          }
              .about-body{
            	  min-height: calc(100vh - (79px + 58px))
            }
            input[type=range] {
            border-radius: 8px;
            height: 7px;
            outline: none;
            transition: background 450ms ease-in;
            -webkit-appearance: none;
          }
            .fs-rangeslider_track{
            	pointer-events: none;
            }
            .is-pink{
            	    pointer-events: auto;
            }
            .menicon{
            	    -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #4a78b8, #6cafe1);
            }
            .messages_active .al-m.active {
            margin-bottom: 0;
          }
            .tw_r.new_m_user.active .user_tick{
            display: block;
          }
            .body.messages_active .panels{
            padding-bottom: 0;
          }
          .body.messages_active .panels_cont{
          padding-bottom: 0;
          }
            .feed-option.active .tw_t{
            font-weight: 500;
          }
              ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(0,0,0,0.1);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(0,0,0,0.2);
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(0,0,0,0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(0,0,0,.9);
          }
            .add_content_btn.disabled{
            	opacity:0.7;
            }
            .text-block-16{
            overflow-wrap: break-word;
            }
            @media screen and (max-width: 1231px) {
          .results{
            grid-template-columns: 1fr 1fr;
          }
          }
            .inner span {
           	position: relative;
              top:2px;
            }
            .s_box{
                appearance: none;
              background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e\");
              background-repeat: no-repeat;
              background-position: right 7px center;
              background-size: 1em;
            }
              @media screen and (max-width: 479px) {
          .results{
            grid-template-columns: 1fr;
          }
          }
          @media screen and (max-width: 1250px) and (min-width: 991px) {
            .slider.w-slider .link-block-7:last-child{
              display: none;
            }
            .div-block-42.sl{
              grid-template-columns: 1fr 1fr 1fr;
            }
          }
            .div-block-78{
            	min-height: calc(100vh - 78px - 70px);
            }
            @media screen and (max-width: 479px) {
           .div-block-78{
            	min-height: calc(100vh - 78px - 101px);
            }
          }
            <style>
            .wday, .month{
            fill: #6d717f;
          }
          .float-right{
            color: #6d717f;
          }
            .more:hover {
                  background-color: #fff;
              background-image: none !important;
          }
            @media screen and (max-width: 479px){
              .dots{
              	    left: calc(50% - 19px);
              }
            }
            	  .chat-box.hidden{
            	height: auto !important;
            }
            @media screen and (max-width: 767px) {
              .chat-box.hidden{
                  height: 100% !important;
              }
                  .full.w-bar .main-content{
                  display:none;
              }
          }
            .chat-2{
            	padding-top: 14px;
            }
            .chat-box.logged-in.hidden{
            	display:none;
            }



          		@supports (-webkit-overflow-scrolling: touch) {
             		textarea.copilot-input-box:focus {
               		font-size: 16px;
             		}
          		}
          		.resize-seperator-block{
              		cursor: ew-resize!important;
                  display:flex;
                  left: -12px!important;
                  width: 20px!important;
              }
              .full:not(.w-bar) .resize-seperator-block{
              	display:none;
              }
              .full:not(.w-bar) .right-content{
              	width:55px!important;
              }
              .div-block-325.rel{
                  position:relative
              }
              .three-dots.active .three-dots-menu{
                  display:block !important;
              }
              .three-dots .three-dots-menu{
                  display:none !important;
              }
              .ui-resizable{
                  position:fixed;
                  left: unset!important;
                  height:auto!important;
              }
              .scrollbar-thin::-webkit-scrollbar{
                  width: 1px;
              }
              .scrollbar-thin::-webkit-scrollbar-track{
                  border-radius: 20px;
              }
              .scrollbar-thin::-webkit-scrollbar-thumb{
                  width: 5px;
              }
              .ft-16{
              	font-size:16px!important;
              }
              @media screen and (max-width:767px){
              	.resize-seperator-block{
                		display:none!important;
                }
              	.chat-2 {
              	position: relative!important;
              	padding-bottom:initial;
              	}
                .div-block-272{
                	position: relative!important;
                }
                .ft-14-xs{
              	font-size:14px!important;
              	}
                .text-block-169{
                	font-size:14px!important;
                }
                .full.mobile-nav-triggerred div.nav{
                	position: fixed;
              		width: 100%;
              		padding-right: 55px;
                }
              }



              .copilot-input-box, .gradient-border{
                  border-image-slice: 1;
                  border-image-source: linear-gradient(198deg, rgba(90, 158, 217,1) 12%, rgba(90, 158, 217,0.30858280812324934) 90%);
              }
              .copilot-input-box.is-generating, .gradient-border.is-generating{
                  --angle: 198deg;
                  border-image-slice: 1;
                  border-image-source: linear-gradient(var(--angle), rgba(90, 158, 217,1) 12%, rgba(90, 158, 217,0.30858280812324934) 90%);
                  animation: .8s rotate linear infinite;
              }
              @keyframes rotate {
                  to {
                      --angle: 120deg;
                  }
              }
              @property --angle {
                  syntax: \'<angle>\';
                  initial-value: 0deg;
                  inherits: false;
              }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="full">
              <div className="main-content">
                <div className="div-block-433">
                  <Header></Header>
                  <div className="mobile_nav-2">
                    <div className="mob_nav-2">
                      <div className="div-block-381">
                        <a className="dash_nav_item" href="#">
                          Home
                        </a>
                      </div>
                      <div className="div-block-381">
                        <a className="dash_nav_item active" href="#">
                          Profile
                        </a>
                      </div>
                      <div className="div-block-381">
                        <a className="dash_nav_item" href="#">
                          Social
                        </a>
                      </div>
                      <div className="div-block-381 last">
                        <a className="dash_nav_item" href="#">
                          Browse
                        </a>
                      </div>
                    </div>
                    <div className="mob_nav-2">
                      <div className="form-block-15 mobile w-form">
                        <form
                          className="form-10"
                          data-name="Email Form"
                          data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb836788"
                          data-wf-page-id="6596f9cde7a06c303cf07fbf"
                          id="email-form"
                          method="get"
                          name="email-form"
                        >
                          <div className="div-block-410">
                            <img
                              alt=""
                              className="image-164"
                              loading="lazy"
                              src="images/magnifying-glass_1magnifying-glass.png"
                            />
                          </div>
                          <input
                            className="text-field-14 n_text w-input"
                            data-name="Email 7"
                            id="email-7"
                            maxLength={256}
                            name="email-7"
                            placeholder="Search"
                            required=""
                            type="email"
                          />
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                      <div className="div-block-521">
                        <div
                          className="div-block-442"
                          data-w-id="f31e1962-462b-8b0d-0045-72a4bb836793"
                        >
                          <img
                            alt=""
                            className="image-173"
                            loading="lazy"
                            src="images/bell.png"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/629f2ca4ae5641d483147dd9_bell.png"
                          />
                          <div className="div-block-399">
                            <div className="div-block-517">
                              <div className="text-block-300">
                                Notifications
                              </div>
                            </div>
                            <div className="div-block-505">
                              <div className="text-block-248">
                                There are no new notifications
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="div-block-442"
                          data-w-id="f31e1962-462b-8b0d-0045-72a4bb83679d"
                        >
                          <img
                            alt=""
                            className="image-173"
                            loading="lazy"
                            sizes="100vw"
                            src="images/setting.png"
                            srcset="images/setting-p-500.png 500w, images/setting.png 512w"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/62a1d584bc8cea2ba5c40d38_setting-p-500.png"
                          />
                          <div className="div-block-399">
                            <div className="div-block-517">
                              <div className="text-block-300">Settings</div>
                            </div>
                            <a
                              className="link-block-30 w-inline-block"
                              href="https://ibl-skills.webflow.io/profile#pp"
                            >
                              <div className="text-block-255">
                                Profile Settings
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="div-block-407">
                          <img
                            alt=""
                            className="image-168"
                            loading="lazy"
                            src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                          />
                          <img
                            alt=""
                            className="image-175"
                            loading="lazy"
                            src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                          />
                          <div className="div-block-399 profile">
                            <div className="div-block-517">
                              <div className="text-block-300">
                                Ashley Miller
                              </div>
                              <div className="text-block-300 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                              className="link-block-30 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-255">Overview</div>
                            </a>
                            <a
                              className="link-block-30 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-255">Profile</div>
                            </a>
                            <a
                              className="link-block-30 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-255">Log Out</div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="panels">
                    <div className="panels_cont">
                      <div className="panel-profile panel">
                        <div className="div-block-421">
                          <div className="profile_menu">
                            <Profilemenubox></Profilemenubox>
                            <a className="prof_menu" href="skills.html">
                              Skills
                            </a>
                            <a className="prof_menu" href="credentials.html">
                              Credentials
                            </a>
                            <a className="prof_menu" href="pathways.html">
                              Pathways
                            </a>
                            <a className="prof_menu" href="programs.html">
                              Programs
                            </a>
                            <a className="prof_menu" href="courses.html">
                              Courses
                            </a>
                            <a
                              aria-current="page"
                              className="prof_menu active w--current"
                              href="public-profile-new.html"
                            >
                              Public Profile
                            </a>
                            <div className="prof_menu hidden" data-name="feed">
                              Feed
                            </div>
                          </div>
                        </div>
                        <div className="profile-panels">
                          <div className="ov_panel active" data-name="pp">
                            <Profilebannerbox></Profilebannerbox>
                            <div className="div-block-502">
                              <div className="text-block-272 pr_t">About</div>
                              <div
                                className="text-block-298"
                                prop-data-names="about"
                                prop-data-value-about="Experienced Data Scientist and DevOps Engineer with a demonstrated history of working in the telecommunications industry. Strong engineering professional skilled in Python, Ansible, Linux, Shell Scripting and other related technologies.#python, #ansible, #automation, #flask, #microservices, #datascientist, #linux"
                              >
                                Experienced Data Scientist and DevOps Engineer
                                with a demonstrated history of working in the
                                telecommunications industry. Strong engineering
                                professional skilled in Python, Ansible, Linux,
                                Shell Scripting and other related
                                technologies.#python, #ansible, #automation,
                                #flask, #microservices, #datascientist, #linux
                              </div>
                            </div>
                            <div className="div-block-502">
                              <div className="text-block-272 pr_t">Skills</div>
                              <div>
                                <div className="w-layout-hflex flex-block-22">
                                  <div className="form-block-15 sk-b w-form">
                                    <Skillsearchbar></Skillsearchbar>
                                    <div className="w-form-done">
                                      <div>
                                        Thank you! Your submission has been
                                        received!
                                      </div>
                                    </div>
                                    <div className="w-form-fail">
                                      <div>
                                        Oops! Something went wrong while
                                        submitting the form.
                                      </div>
                                    </div>
                                  </div>
                                  <Addskillbtn></Addskillbtn>
                                </div>
                                <div className="sk_cont">
                                  <div className="div-block-483">
                                    <div className="text-block-278">
                                      Self- Reported
                                    </div>
                                    <div className="text-block-254 mg_l hidden">
                                      Manage Skills
                                    </div>
                                  </div>
                                  <div className="br_row">
                                    <div
                                      className="slider-9 w-slider"
                                      data-animation="slide"
                                      data-autoplay="false"
                                      data-autoplay-limit={0}
                                      data-delay={4000}
                                      data-disable-swipe="false"
                                      data-duration={500}
                                      data-easing="ease"
                                      data-hide-arrows="false"
                                      data-infinite="true"
                                      data-nav-spacing={3}
                                    >
                                      <div className="mask w-slider-mask">
                                        <div className="slide w-slide">
                                          <div className="div-block-430">
                                            <Skillslidebox></Skillslidebox>
                                            <div className="item-box skill_box o skill-link">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Python
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 33%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>1</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Python Fundamentals
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    2 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 991px) 100vw, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box o skill-link">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Data Science
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 100%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>3</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Introduction to Data Science
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 991px) 100vw, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box skill-link">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Machine Learning
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 50%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>2</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Data Algorithms{' '}
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    3 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 991px) 100vw, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="left-arrow w-slider-arrow-left">
                                        <img
                                          alt=""
                                          className="image-160"
                                          loading="lazy"
                                          src="images/next-3_1next-3.png"
                                        />
                                      </div>
                                      <div className="right-arrow-8 w-slider-arrow-right">
                                        <img
                                          alt=""
                                          className="image-176"
                                          loading="lazy"
                                          src="images/next-1_1next-1.png"
                                        />
                                      </div>
                                      <div className="slide-nav-4 w-slider-nav w-round"></div>
                                    </div>
                                    <div
                                      className="slider-9 tablet w-slider"
                                      data-animation="slide"
                                      data-autoplay="false"
                                      data-autoplay-limit={0}
                                      data-delay={4000}
                                      data-disable-swipe="false"
                                      data-duration={500}
                                      data-easing="ease"
                                      data-hide-arrows="false"
                                      data-infinite="true"
                                      data-nav-spacing={3}
                                    >
                                      <div className="mask w-slider-mask">
                                        <div className="slide w-slide">
                                          <div className="div-block-430">
                                            <div
                                              className="item-box skill_box"
                                              id="w-node-f31e1962-462b-8b0d-0045-72a4bb836d93-3cf07fbf"
                                            >
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Javascript
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 30%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>3</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Javascript Basics
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    1 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Python
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 90%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>9</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Python Fundamentals
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    2 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Machine Learning
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 20%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>2</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Data Algorithms{' '}
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    3 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="left-arrow w-slider-arrow-left">
                                        <img
                                          alt=""
                                          className="image-160"
                                          loading="lazy"
                                          src="images/next-3_1next-3.png"
                                        />
                                      </div>
                                      <div className="right-arrow-8 w-slider-arrow-right">
                                        <img
                                          alt=""
                                          className="image-176"
                                          loading="lazy"
                                          src="images/next-1_1next-1.png"
                                        />
                                      </div>
                                      <div className="slide-nav-4 w-slider-nav w-round"></div>
                                    </div>
                                    <div
                                      className="slider-9 mobile w-slider"
                                      data-animation="slide"
                                      data-autoplay="false"
                                      data-autoplay-limit={0}
                                      data-delay={4000}
                                      data-disable-swipe="false"
                                      data-duration={500}
                                      data-easing="ease"
                                      data-hide-arrows="false"
                                      data-infinite="true"
                                      data-nav-spacing={3}
                                    >
                                      <div className="mask w-slider-mask">
                                        <div className="slide w-slide">
                                          <div className="div-block-430 mob">
                                            <div
                                              className="item-box skill_box"
                                              id="w-node-f31e1962-462b-8b0d-0045-72a4bb836dc9-3cf07fbf"
                                            >
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Javascript
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 30%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>3</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Javascript Basics
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    1 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="left-arrow w-slider-arrow-left">
                                        <img
                                          alt=""
                                          className="image-160"
                                          loading="lazy"
                                          src="images/next-3_1next-3.png"
                                        />
                                      </div>
                                      <div className="right-arrow-8 w-slider-arrow-right">
                                        <img
                                          alt=""
                                          className="image-176"
                                          loading="lazy"
                                          src="images/next-1_1next-1.png"
                                        />
                                      </div>
                                      <div className="slide-nav-4 w-slider-nav w-round"></div>
                                    </div>
                                  </div>
                                  <div className="no-skills-view self-reported">
                                    <img
                                      alt=""
                                      className="image-141 tools-img"
                                      loading="lazy"
                                      src="images/skills_icon_1skills_icon.png"
                                    />
                                    <div>
                                      You don't have any self-reported skills
                                      yet.
                                    </div>
                                  </div>
                                </div>
                                <div className="sk_cont">
                                  <div className="w-layout-hflex flex-block-22">
                                    <div className="form-block-15 sk-b w-form">
                                      <Skillsearchbar></Skillsearchbar>
                                      <div className="w-form-done">
                                        <div>
                                          Thank you! Your submission has been
                                          received!
                                        </div>
                                      </div>
                                      <div className="w-form-fail">
                                        <div>
                                          Oops! Something went wrong while
                                          submitting the form.
                                        </div>
                                      </div>
                                    </div>
                                    <Addskillbtn></Addskillbtn>
                                  </div>
                                  <div className="div-block-483">
                                    <div className="text-block-278">
                                      Desired
                                    </div>
                                    <div className="text-block-254 mg_l hidden">
                                      Manage Skills
                                    </div>
                                  </div>
                                  <div className="br_row">
                                    <div
                                      className="slider-9 w-slider"
                                      data-animation="slide"
                                      data-autoplay="false"
                                      data-autoplay-limit={0}
                                      data-delay={4000}
                                      data-disable-swipe="false"
                                      data-duration={500}
                                      data-easing="ease"
                                      data-hide-arrows="false"
                                      data-infinite="true"
                                      data-nav-spacing={3}
                                    >
                                      <div className="mask w-slider-mask">
                                        <div className="slide w-slide">
                                          <div className="div-block-430">
                                            <Skillslidebox></Skillslidebox>
                                            <div className="item-box skill_box o skill-link">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Python
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 33%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>1</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Python Fundamentals
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    2 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 991px) 100vw, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box o skill-link">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Data Science
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 100%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>3</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Introduction to Data Science
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 991px) 100vw, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box skill-link">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Machine Learning
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 50%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>2</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Data Algorithms{' '}
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    3 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 991px) 100vw, (max-width: 1279px) 2vw, (max-width: 1439px) 20px, 1vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="left-arrow w-slider-arrow-left">
                                        <img
                                          alt=""
                                          className="image-160"
                                          loading="lazy"
                                          src="images/next-3_1next-3.png"
                                        />
                                      </div>
                                      <div className="right-arrow-8 w-slider-arrow-right">
                                        <img
                                          alt=""
                                          className="image-176"
                                          loading="lazy"
                                          src="images/next-1_1next-1.png"
                                        />
                                      </div>
                                      <div className="slide-nav-4 w-slider-nav w-round"></div>
                                    </div>
                                    <div
                                      className="slider-9 tablet w-slider"
                                      data-animation="slide"
                                      data-autoplay="false"
                                      data-autoplay-limit={0}
                                      data-delay={4000}
                                      data-disable-swipe="false"
                                      data-duration={500}
                                      data-easing="ease"
                                      data-hide-arrows="false"
                                      data-infinite="true"
                                      data-nav-spacing={3}
                                    >
                                      <div className="mask w-slider-mask">
                                        <div className="slide w-slide">
                                          <div className="div-block-430">
                                            <div
                                              className="item-box skill_box"
                                              id="w-node-f31e1962-462b-8b0d-0045-72a4bb836e2a-3cf07fbf"
                                            >
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Javascript
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 30%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>3</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Javascript Basics
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    1 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Python
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 90%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>9</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Python Fundamentals
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    2 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                            <div className="item-box skill_box">
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  Machine Learning
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 20%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>2</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Data Algorithms{' '}
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    3 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 100vw, (max-width: 991px) 20px, 100vw"
                                                  src="images/star_1.png"
                                                  srcset="images/star_1-p-500.png 500w, images/star_1.png 512w"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="left-arrow w-slider-arrow-left">
                                        <img
                                          alt=""
                                          className="image-160"
                                          loading="lazy"
                                          src="images/next-3_1next-3.png"
                                        />
                                      </div>
                                      <div className="right-arrow-8 w-slider-arrow-right">
                                        <img
                                          alt=""
                                          className="image-176"
                                          loading="lazy"
                                          src="images/next-1_1next-1.png"
                                        />
                                      </div>
                                      <div className="slide-nav-4 w-slider-nav w-round"></div>
                                    </div>
                                    <div
                                      className="slider-9 mobile w-slider"
                                      data-animation="slide"
                                      data-autoplay="false"
                                      data-autoplay-limit={0}
                                      data-delay={4000}
                                      data-disable-swipe="false"
                                      data-duration={500}
                                      data-easing="ease"
                                      data-hide-arrows="false"
                                      data-infinite="true"
                                      data-nav-spacing={3}
                                    >
                                      <div className="mask w-slider-mask">
                                        <div className="slide w-slide">
                                          <div className="div-block-430 mob">
                                            <div
                                              className="item-box skill_box"
                                              id="w-node-f31e1962-462b-8b0d-0045-72a4bb836e60-3cf07fbf"
                                            >
                                              <div className="div-block-386">
                                                <img
                                                  alt=""
                                                  className="image-141"
                                                  loading="lazy"
                                                  src="images/skills_icon_1skills_icon.png"
                                                />
                                                <div className="text-block-257">
                                                  HTML
                                                </div>
                                                <div>
                                                  <div className="html-embed-10 w-embed">
                                                    <style
                                                      dangerouslySetInnerHTML={{
                                                        __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                                      }}
                                                    />
                                                    <div
                                                      className="circle per-25"
                                                      style={{
                                                        backgroundImage:
                                                          'conic-gradient(#528ac1 30%, #def 0)',
                                                      }}
                                                    >
                                                      <div className="inner">
                                                        <span>3</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="text-block-252">
                                                  Based on:{' '}
                                                  <span className="text-span-10">
                                                    Javascript Basics
                                                  </span>{' '}
                                                  and{' '}
                                                  <span className="text-span-10">
                                                    1 more
                                                  </span>
                                                </div>
                                                <img
                                                  alt=""
                                                  className="image-148"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 20px, 100vw"
                                                  src="images/62a1eeff0b8be26d0831882b_star.png"
                                                  srcset="images/62a1eeff0b8be26d0831882b_star-p-500.png 500w, images/62a1eeff0b8be26d0831882b_star.png 512w"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="left-arrow w-slider-arrow-left">
                                        <img
                                          alt=""
                                          className="image-160"
                                          loading="lazy"
                                          src="images/next-3_1next-3.png"
                                        />
                                      </div>
                                      <div className="right-arrow-8 w-slider-arrow-right">
                                        <img
                                          alt=""
                                          className="image-176"
                                          loading="lazy"
                                          src="images/next-1_1next-1.png"
                                        />
                                      </div>
                                      <div className="slide-nav-4 w-slider-nav w-round"></div>
                                    </div>
                                  </div>
                                  <div className="no-skills-view desired-skills">
                                    <img
                                      alt=""
                                      className="image-141 tools-img"
                                      loading="lazy"
                                      src="images/skills_icon_1skills_icon.png"
                                    />
                                    <div>
                                      No desired skills yet.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Credentiallayoutbox></Credentiallayoutbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popup_div">
                    <div className="popup_cont sk">
                      <div className="dc_popup" data-name="followers">
                        <div className="div-block-520">
                          <div>Discover Credentials</div>
                          <img
                            alt=""
                            className="cancel_dc"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525 cr_res">
                          <div className="div-block-469 sk_s">
                            <div className="form-block-15 s_skill w-form">
                              <form
                                className="form-10"
                                data-name="Email Form"
                                data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb83711f"
                                data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div className="div-block-410">
                                  <img
                                    alt=""
                                    className="image-164"
                                    loading="lazy"
                                    src="images/magnifying-glass_1magnifying-glass.png"
                                  />
                                </div>
                                <input
                                  className="text-field-14 n_text w-input"
                                  data-name="Email 4"
                                  id="email-4"
                                  maxLength={256}
                                  name="email-4"
                                  placeholder="Search for credentials"
                                  required=""
                                  type="email"
                                />
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="cred_res">
                            <a
                              className="cred_link cr_r w-inline-block"
                              href="#"
                            >
                              <div className="cr_box_flex cr_res">
                                <img
                                  alt=""
                                  className="image-153 cr_res"
                                  loading="lazy"
                                  sizes="100vw"
                                  src="images/b1.png"
                                  srcset="images/b1-p-500.png 500w, images/b1.png 512w"
                                />
                                <div>
                                  <div className="text-block-232">
                                    Introduction to Javascript
                                  </div>
                                  <div className="text-block-239">
                                    Stanford University
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="cred_link cr_r w-inline-block"
                              href="#"
                            >
                              <div className="cr_box_flex cr_res">
                                <img
                                  alt=""
                                  className="image-153 cr_res"
                                  loading="lazy"
                                  sizes="100vw"
                                  src="images/b2.png"
                                  srcset="images/b2-p-500.png 500w, images/b2.png 512w"
                                />
                                <div>
                                  <div className="text-block-232">
                                    AI and Data Exploration
                                  </div>
                                  <div className="text-block-239">
                                    Stanford University
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="cred_link cr_r last_item w-inline-block"
                              href="#"
                            >
                              <div className="cr_box_flex cr_res">
                                <img
                                  alt=""
                                  className="image-153 cr_res"
                                  loading="lazy"
                                  sizes="100vw"
                                  src="images/b3.png"
                                  srcset="images/b3-p-500.png 500w, images/b3.png 512w"
                                />
                                <div>
                                  <div className="text-block-232">
                                    Java Development
                                  </div>
                                  <div className="text-block-239">
                                    Stanford University
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="popup-f">
                          <div className="div-block-475 cancel_dc_div">
                            <div className="text-block-284 cancel_dc">
                              Cancel
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="edit_profile_pop" data-name="followers">
                        <div className="div-block-520">
                          <div>Edit Profile Information</div>
                          <img
                            alt=""
                            className="cancel_edit_profile"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525">
                          <div className="div-block-469 sk_s form_div">
                            <div className="form_row">
                              <div className="text-block-297">Full Name</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837151"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn"
                                    id="fn"
                                    maxLength={256}
                                    name="fn"
                                    placeholder="Enter your full name"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">Email</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb83715d"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your email"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">Title</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837169"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your title"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">
                                Current Position
                              </div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837175"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your current position"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">
                                Current Position Icon
                              </div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837181"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your current position icon"
                                    required=""
                                    type="text"
                                  />
                                  <div className="div-block-475 file_upload">
                                    <div className="text-block-284 add_skill_text">
                                      Upload
                                    </div>
                                  </div>
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">Education</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb837190"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your education"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">
                                Education Icon
                              </div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb83719c"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your education icon"
                                    required=""
                                    type="text"
                                  />
                                  <div className="div-block-475 file_upload">
                                    <div className="text-block-284 add_skill_text">
                                      Upload
                                    </div>
                                  </div>
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">Facebook</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371ab"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your Facebook username"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="text-block-297">Linkedin</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371b7"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your LinkedIn username"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form_row last_row">
                              <div className="text-block-297">Twitter</div>
                              <div className="form-block-15 s_skill w-form">
                                <form
                                  className="form-10"
                                  data-name="Email Form"
                                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371c3"
                                  data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <input
                                    className="text-field-14 form_text w-input"
                                    data-name="Fn 2"
                                    id="fn-2"
                                    maxLength={256}
                                    name="fn-2"
                                    placeholder="Enter your Twitter Username"
                                    required=""
                                    type="text"
                                  />
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="popup-f add_content">
                          <div className="div-block-475 cancel_edit_prof">
                            <div className="text-block-284 cancel_dc">
                              Cancel
                            </div>
                          </div>
                          <div className="div-block-475 save_profile_info">
                            <div className="text-block-284 add_skill_text">
                              Save
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="add_skill_popup" data-name="followers">
                        <div className="div-block-520">
                          <div>Add Skill</div>
                          <img
                            alt=""
                            className="cancel_add_skill"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525">
                          <div className="div-block-469 sk_s">
                            <div className="form-block-15 s_skill w-form">
                              <form
                                className="form-10"
                                data-name="Email Form"
                                data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371da"
                                data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div className="div-block-410">
                                  <img
                                    alt=""
                                    className="image-164"
                                    loading="lazy"
                                    src="images/magnifying-glass_1magnifying-glass.png"
                                  />
                                </div>
                                <input
                                  className="text-field-14 n_text w-input"
                                  data-name="Email 4"
                                  id="email-4"
                                  maxLength={256}
                                  name="email-4"
                                  placeholder="Search for skills"
                                  required=""
                                  type="email"
                                />
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="popup-f">
                          <div className="div-block-475 confirm_add_skill">
                            <div className="text-block-284 add_skill_text">
                              Add Skill
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="skill_report_popup" data-name="followers">
                        <div className="div-block-520">
                          <div>Javascript</div>
                          <img
                            alt=""
                            className="cancel_skill_report"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525">
                          <div className="div-block-469 sk_s">
                            <div className="div-block-441">
                              <img
                                alt=""
                                className="image-154"
                                loading="lazy"
                                src="images/skills_icon_1skills_icon.png"
                              />
                              <div>
                                <div className="text-block-303">
                                  Self Rating
                                </div>
                                <div className="text-block-267">Level 3</div>
                                <div className="edit_rating">Edit Rating</div>
                              </div>
                              <div className="item_options">
                                <div className="item_options_triger">
                                  <img
                                    alt=""
                                    className="image-182"
                                    loading="lazy"
                                    src="images/menu_1menu.png"
                                  />
                                </div>
                                <div className="options_div skill_options">
                                  <div className="text-block-238">
                                    Clear Rating
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="popup-f">
                          <div className="div-block-475 confirm_skill_report">
                            <div className="text-block-284 add_skill_text">
                              Save
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="rate_skill_popup" data-name="followers">
                        <div className="div-block-520">
                          <div>Rate your expertise in "Javascript"</div>
                          <img
                            alt=""
                            className="rate_skill_close"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525">
                          <div className="div-block-469 sk_s">
                            <div className="rate_skill r_popup">
                              <div className="rate_skill_block">
                                <div className="div-block-500">
                                  <div className="step_n">1</div>
                                  <div className="step_n">2</div>
                                  <div className="step_n">3</div>
                                  <div className="step_n">4</div>
                                  <div className="step_n">5</div>
                                  <div className="step_n">6</div>
                                  <div className="step_n">7</div>
                                  <div className="step_n">8</div>
                                  <div className="step_n">9</div>
                                  <div className="step_n">10</div>
                                </div>
                                <div className="fs-rangeslider_form w-form">
                                  <form
                                    data-name="Email Form"
                                    data-wf-element-id="4053d254-3d00-4cce-3b43-b31499cd393f"
                                    data-wf-page-id="6596f9cde7a06c303cf07fbf"
                                    id="email-form"
                                    method="get"
                                    name="email-form"
                                  >
                                    <div
                                      className="fs-rangeslider_wrapper"
                                      fs-rangeslider-element="wrapper"
                                      fs-rangeslider-formatdisplay="true"
                                      fs-rangeslider-max={90}
                                      fs-rangeslider-min={0}
                                      fs-rangeslider-step={10}
                                    >
                                      <div
                                        className="fs-rangeslider_track"
                                        fs-rangeslider-element="track"
                                      >
                                        <div
                                          className="fs-rangeslider_handle is-pink"
                                          fs-rangeslider-element="handle"
                                        >
                                          <div className="fs-rangeslider_handle-value"></div>
                                        </div>
                                        <div
                                          className="fs-rangeslider_fill"
                                          fs-rangeslider-element="fill"
                                        ></div>
                                      </div>
                                      <input
                                        className="fs-rangeslider_input w-input"
                                        data-name="From 3"
                                        fs-cmsfilter-field="price"
                                        fs-cmsfilter-range="from"
                                        id="From-3"
                                        maxLength={256}
                                        name="From-3"
                                        placeholder="From"
                                        type="text"
                                      />
                                      <div className="fs-range_values hidden"></div>
                                    </div>
                                  </form>
                                  <div className="w-form-done">
                                    <div>
                                      Thank you! Your submission has been
                                      received!
                                    </div>
                                  </div>
                                  <div className="w-form-fail">
                                    <div>
                                      Oops! Something went wrong while
                                      submitting the form.
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-468">
                                  <div className="text-block-259">Beginner</div>
                                  <div className="text-block-259 mgl">
                                    Expert
                                  </div>
                                </div>
                                <div className="div-block-416">
                                  <div className="rate_level">
                                    <div className="html-embed-10 rate_level w-embed">
                                      <style
                                        dangerouslySetInnerHTML={{
                                          __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                        }}
                                      />
                                      <div
                                        className="circle per-25"
                                        style={{
                                          backgroundImage:
                                            'conic-gradient(#528ac1 30%, #def 0)',
                                        }}
                                      >
                                        <div className="inner">
                                          <span>3</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-263">
                                    Can complete narrow and limited tasks
                                    requiring basic skills with direct
                                    supervision or guidance.
                                  </div>
                                  <div className="div-block-503"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="popup-f rate">
                          <div className="div-block-475 cancel_skill_rate">
                            <div className="text-block-284 add_skill_text cancel">
                              Cancel
                            </div>
                          </div>
                          <div className="div-block-475 delete-skills">
                            <div className="text-block-284 add_skill_text cancel delete-s">
                              Delete skill
                            </div>
                          </div>
                          <div className="div-block-475 confirm_skill_rate">
                            <div className="text-block-284 add_skill_text">
                              Confirm
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="social_div">
                    <div className="social_cont">
                      <div
                        className="social_box followers"
                        data-name="followers"
                      >
                        <div className="div-block-520">
                          <div>Followers</div>
                          <img
                            alt=""
                            className="image-177"
                            data-w-id="f31e1962-462b-8b0d-0045-72a4bb837247"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525">
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Sara Joyner</div>
                                <div className="text-block-275">
                                  Manual Testing Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Eathan Adam</div>
                                <div className="text-block-275">
                                  Mining Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Maira Paul</div>
                                <div className="text-block-275">
                                  Technical Support Representative
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Nimra Jefferson</div>
                                <div className="text-block-275">
                                  Software Quality Assurance
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Kealan Walters</div>
                                <div className="text-block-275">
                                  Computer Science Professor
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                sizes="100vw"
                                src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                              />
                              <div className="div-block-488">
                                <div className="bname">Isobella Simmonds</div>
                                <div className="text-block-275">
                                  Product Manager
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="social_box following"
                        data-name="followers"
                      >
                        <div className="div-block-520">
                          <div>Following</div>
                          <img
                            alt=""
                            className="image-177 following"
                            data-w-id="f31e1962-462b-8b0d-0045-72a4bb83728f"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-525">
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Sara Joyner</div>
                                <div className="text-block-275">
                                  Manual Testing Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Eathan Adam</div>
                                <div className="text-block-275">
                                  Mining Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Maira Paul</div>
                                <div className="text-block-275">
                                  Technical Support Representative
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Nimra Jefferson</div>
                                <div className="text-block-275">
                                  Software Quality Assurance
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-488">
                                <div className="bname">Kealan Walters</div>
                                <div className="text-block-275">
                                  Computer Science Professor
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-469">
                            <a
                              className="link-block-24 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-165"
                                loading="lazy"
                                sizes="100vw"
                                src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                              />
                              <div className="div-block-488">
                                <div className="bname">Isobella Simmonds</div>
                                <div className="text-block-275">
                                  Product Manager
                                </div>
                              </div>
                            </a>
                            <div className="div-block-434">
                              <div className="text-block-261">Remove</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot></Copilot>
            </div>
          </div>
        </span>
      </span>
    );
  }
}

export default PublicProfileNewView;

/* eslint-enable */
